import * as React from "react";
import { Slot } from "@radix-ui/react-slot";

import { cn } from "@/common/utils/className";
import { buttonVariants, type ButtonVariantProps } from "@/domain/ui/buttonVariants";

type ButtonProps = React.ComponentProps<"button"> &
  ButtonVariantProps & {
    asChild?: boolean;
    leadingIcon?: React.ReactNode;
    trailingIcon?: React.ReactNode;
  };

function Button({ className, variant, size, leadingIcon, trailingIcon, asChild = false, children, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp data-slot="button" className={cn(buttonVariants({ variant, size, className }))} {...props}>
      {leadingIcon && <span className="inline-flex items-center">{leadingIcon}</span>}
      {children}
      {trailingIcon && <span className="inline-flex items-center">{trailingIcon}</span>}
    </Comp>
  );
}

export type { ButtonProps };
export { Button };
